const NODE_ENV = process.env.NODE_ENV || 'production';
const environments = {
  development: {
    apiKey: 'AIzaSyCf5iA8P2dipwk0pmFgSnx0UZNtBTrswC0',
    apiURL: 'https://development.sayi.do/api',
    authDomain: 'say-i-do-development-910e8.firebaseapp.com',
    baseDomain: 'https://development.sayi.do',
    databaseURL: 'https://say-i-do-development-910e8.firebaseio.com',
    name: 'development',
    projectId: 'say-i-do-development-910e8',
  },
  production: {
    apiKey: 'AIzaSyB4K_akYk86NlByFhobjOmutgjpk9o02Lg',
    apiURL: 'https://sayi.do/api',
    authDomain: 'project-7552620506581992652.firebaseapp.com',
    baseDomain: 'https://sayi.do',
    databaseURL: 'https://project-7552620506581992652.firebaseio.com',
    name: 'production',
    projectId: 'project-7552620506581992652',
  },
};
const env = environments[NODE_ENV] ? NODE_ENV : 'development';
export default environments[env];
